module.exports = __webpack_public_path__ + "static/media/20170806_39day_1929AT.7bca2027.jpg";